import type { UseQueryResult } from "@tanstack/react-query";

import { useOrgScopedQuery } from "../../query/scope";
import { fetchTrustRules } from "./api";
import type { TrustRuleResponse } from "./api";

export function useTrustRules(): UseQueryResult<TrustRuleResponse[], Error> {
  return useOrgScopedQuery<TrustRuleResponse[]>({
    key: ["trustRules"],
    queryFn: () => fetchTrustRules(),
    retry: false,
  });
}
